(() => {
 if (customElements.get('lf-catalog-groups')) return;
 customElements.define('lf-catalog-groups', class extends HTMLElement {
  connectedCallback() {
   this.life = new AbortController();
   this.status = this.querySelector('.lfc-group-status');
   this.original = new URL(location.href);
   this.group = 'current';
   const signal = this.life.signal;
   this.addEventListener('click', event => {
    const chip = event.target.closest('[data-lfc-group]');
    if (!chip || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (chip.dataset.configured !== 'true') {
     event.preventDefault();
     this.status.textContent = 'Nhóm này chưa được cấu hình nguồn sản phẩm.';
     return;
    }
    if (chip.dataset.action !== 'inline') return;
    event.preventDefault();
    this.load(chip.href, chip.dataset.lfcGroup, true);
   }, {signal});
   document.addEventListener('click', event => {
    const link = event.target.closest('.lfc-pagination a,.lfc-filters .lfc-actions a');
    if (!link || !this.isConnected || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    this.load(link.href, this.group, true);
   }, {signal});
   document.addEventListener('submit', event => {
    if (!event.target.matches('.lfc-filters form')) return;
    event.preventDefault();
    const url = new URL(event.target.action, location.href);
    url.search = new URLSearchParams(new FormData(event.target)).toString();
    this.load(url.href, this.group, true);
   }, {signal});
   window.addEventListener('popstate', () => this.restore(), {signal});
   const requested = new URL(location.href).searchParams.get('lf_group');
   if (requested && this.chip(requested)) this.restore();
  }
  chip(key) { return [...this.querySelectorAll('[data-lfc-group]')].find(x => x.dataset.lfcGroup === key); }
  restore() {
   const current = new URL(location.href);
   const key = current.searchParams.get('lf_group') || 'current';
   const chip = this.chip(key) || this.chip('current');
   const url = new URL(chip.href, location.href);
   for (const [name,value] of current.searchParams) {
    if (name === 'page' || name === 'sort_by' || name.startsWith('filter.')) url.searchParams.set(name,value);
   }
   this.load(url.href, chip.dataset.lfcGroup, false, false);
  }
  async load(href, key, updateHistory, scroll = true) {
   this.request?.abort();
   const request = this.request = new AbortController();
   const host = document.querySelector('.lfc-products');
   if (!host) return;
   const url = new URL(href, location.href);
   if (url.origin !== location.origin) return;
   url.searchParams.set('view','lf-catalog');
   url.searchParams.delete('lf_group');
   for (const name of ['preview_theme_id','pb']) {
    if (this.original.searchParams.has(name)) url.searchParams.set(name,this.original.searchParams.get(name));
   }
   url.hash = '';
   const section = host.dataset.section;
   if (section) url.searchParams.set('section_id',section);
   host.setAttribute('aria-busy','true');
   this.status.textContent = 'Đang tải sản phẩm…';
   try {
    const response = await fetch(url, {signal:request.signal});
    if (!response.ok) throw new Error('request');
    const doc = new DOMParser().parseFromString(await response.text(),'text/html');
    const next = doc.querySelector('.lfc-products');
    if (!next) throw new Error('section');
    // Only replace product contents; banner, icon rail and host layout stay in place.
    host.replaceChildren(...next.childNodes);
    this.group = key;
    this.querySelectorAll('[data-lfc-group]').forEach(chip => {
     if (chip.dataset.lfcGroup === key) chip.setAttribute('aria-current','page');
     else chip.removeAttribute('aria-current');
    });
    const chip = this.chip(key);
    this.status.textContent = '';
    const count = host.querySelector('.lfc-count');
    if (count && key !== 'current') count.append(document.createTextNode(' · ' + (chip?.dataset.label || '')));
    if (updateHistory) {
     const visible = new URL(location.href);
     visible.pathname = this.dataset.baseUrl;
     for (const name of [...visible.searchParams.keys()]) {
      if (name === 'page' || name === 'sort_by' || name === 'lf_group' || name.startsWith('filter.')) visible.searchParams.delete(name);
     }
     for (const [name,value] of url.searchParams) {
      if (name === 'page' || name === 'sort_by' || name.startsWith('filter.')) visible.searchParams.set(name,value);
     }
     visible.searchParams.set('view','lf-catalog');
     if (key !== 'current') visible.searchParams.set('lf_group',key);
     visible.hash = 'lfc-products';
     history.pushState({},'',visible);
    }
    if (scroll) host.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
   } catch (error) {
    if (error.name !== 'AbortError') this.status.textContent = 'Chưa tải được sản phẩm. Vui lòng bấm lại nhóm để thử lại.';
   } finally {
    if (this.request === request) host.removeAttribute('aria-busy');
   }
  }
  disconnectedCallback() { this.life?.abort(); this.request?.abort(); }
 });
})();
